export default __webpack_public_path__ + "static/media/smile_yellow.6be91da7.svg";